import { getAuth } from 'firebase/auth';
import apiUrls from '../api/apiUrls';

const fetchWithAuth = async (url, options = {}) => {
  const { headers: customHeaders, authUser, ...fetchOptions } = options;
  const auth = getAuth();
  const user = authUser ?? auth.currentUser;

  if (!user) {
    throw new Error('User not authenticated');
  }

  const token = await user.getIdToken();

  const headers = {
    ...customHeaders,
    Authorization: `Bearer ${token}`,
    'Content-Type': 'application/json',
  };

  return fetch(url, {
    ...fetchOptions,
    headers,
  });
};

export default fetchWithAuth;

export const saveUserApi = async (userData, authUser) => {
  const url = apiUrls.saveUserApi;
  const options = {
    method: "POST",
    body: JSON.stringify(userData),
    authUser,
  };
  //console.log(userData);
  return fetchWithAuth(url, options);
};
